import { render, staticRenderFns } from "./searchGoods.vue?vue&type=template&id=3047b042&scoped=true&"
import script from "./searchGoods.vue?vue&type=script&lang=js&"
export * from "./searchGoods.vue?vue&type=script&lang=js&"
import style0 from "./searchGoods.vue?vue&type=style&index=0&id=3047b042&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3047b042",
  null
  
)

export default component.exports